import { ElementType, PropsWithChildren, ReactNode } from 'react'
import classNames from 'classnames'

import { CircleSuccessLineIcon } from '../../../icons/CircleSuccessLineIcon'
import { IconProps } from '../../../icons/IconProps'

import styles from './DropdownListItem.module.scss'

export interface DropdownListItemProps {
  variant?: 'default' | 'compact'
  onClick?: () => void
  flag?: ReactNode
  isActive?: boolean
  hasCheckMark?: boolean
  startIcon?: ElementType<IconProps>
  endIcon?: ElementType<IconProps>
  className?: string
}

export const DropdownListItem: React.FC<PropsWithChildren<DropdownListItemProps>> = (props) => {
  const {
    children,
    flag,
    startIcon: StartIcon,
    endIcon: EndIcon,
    isActive,
    hasCheckMark,
    onClick,
    className,
  } = props

  return (
    <div
      className={classNames(styles.dropdownListItem, className, {
        [styles.compact]: props.variant === 'compact',
        [styles.withFlag]: flag,
        [styles.active]: isActive,
      })}
      onClick={() => onClick?.()}
    >
      {flag}
      {!flag && StartIcon && <StartIcon size={24} />}
      {children}
      {EndIcon && (
        <span className={styles.rightIcon}>
          <EndIcon size={24} />
        </span>
      )}
      {isActive && hasCheckMark && (
        <span className={styles.rightIcon}>
          <CircleSuccessLineIcon color='foregroundAccent' />
        </span>
      )}
    </div>
  )
}
